import * as React from 'react';

import styled from '@emotion/styled';
import { Paper, Grid, makeStyles } from '@material-ui/core';
import { getDate, isSameMonth, isToday, format, isWithinInterval } from 'date-fns';

import { TextBodyMedium } from 'uiToolkitV1/Typography';

// eslint-disable-next-line no-unused-vars
import { NavigationAction } from '../types';
import { chunks, getDaysInMonth, isStartOfRange, isEndOfRange, inDateRange, isRangeSameDay } from '../utils';
import Day from './Day';
import Header from './Header';

const WEEK_DAYS = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'];

const useStyles = makeStyles(() => ({
  root: {
    width: 310,
  },
  weekDaysContainer: {
    marginTop: 10,
    paddingLeft: 30,
    paddingRight: 30,
  },
  daysContainer: {
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: 8,
    marginBottom: 12,
  },
}));

const Month = (props) => {
  const classes = useStyles();

  const { helpers, handlers, value: date, dateRange, marker, setValue: setDate, minDate, maxDate, mr } = props;

  // eslint-disable-next-line react/destructuring-assignment
  const [back, forward] = props.navState;

  return (
    <StyledPaper square elevation={0} className={classes.root} mr={mr}>
      <Grid container>
        <Header
          date={date}
          setDate={setDate}
          nextDisabled={!forward}
          prevDisabled={!back}
          onClickPrevious={() => handlers.onMonthNavigate(marker, NavigationAction.Previous)}
          onClickNext={() => handlers.onMonthNavigate(marker, NavigationAction.Next)}
          minDate={minDate}
          maxDate={maxDate}
        />

        <Grid item container direction="row" justifyContent="space-between" className={classes.weekDaysContainer}>
          {WEEK_DAYS.map((day) => (
            <TextBodyMedium sx={{ userSelect: 'none' }} color="text.g3" key={day} bold>
              {day}
            </TextBodyMedium>
          ))}
        </Grid>

        <Grid item container direction="column" justifyContent="space-between" className={classes.daysContainer}>
          {chunks(getDaysInMonth(date), 7).map((week, idx) => (
            // eslint-disable-next-line react/no-array-index-key
            <Grid key={idx} container direction="row" justifyContent="center">
              {week.map((day) => {
                const isStart = isStartOfRange(dateRange, day);
                const isEnd = isEndOfRange(dateRange, day);
                const isRangeOneDay = isRangeSameDay(dateRange);
                const highlighted = inDateRange(dateRange, day) || helpers.inHoverRange(day);

                return (
                  <Day
                    key={format(day, 'MM-dd-yyyy')}
                    filled={isStart || isEnd}
                    outlined={isToday(day)}
                    highlighted={highlighted && !isRangeOneDay}
                    isOutOfRangeDay={!isWithinInterval(day, { start: minDate, end: maxDate })}
                    isSuffixPrefixDay={!isSameMonth(date, day)}
                    startOfRange={isStart && !isRangeOneDay}
                    endOfRange={isEnd && !isRangeOneDay}
                    onClick={() => handlers.onDayClick(day)}
                    onHover={() => handlers.onDayHover(day)}
                    value={getDate(day)}
                    isToday={isToday(day)}
                    isStart={isStart}
                    isEnd={isEnd}
                  />
                );
              })}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </StyledPaper>
  );
};

const StyledPaper = styled(Paper)`
  background: ${(props) => props.theme.colors.neutral.F5F7F9};
  border-radius: 4px;
  margin-right: ${(props) => props.mr};
`;

export default Month;
